import * as React from 'react';
import { withStyles, StyleRulesCallback, WithStyles } from '@material-ui/core/styles';
import { Add as AddIcon } from '@material-ui/icons';
import { observer } from 'mobx-react';
import { IObservableObject, IObservableValue, observable, observe } from 'mobx';
import { defaultPageable, emptyPage, Page, Pageable } from '../../api/pageable';
import { Spinner } from '../../spinner/Spinner';
import EmptyPage from '../../components/emptyPage/EmptyPage';
import { translation } from '../../i18n';
import { QuestionnaireDto } from './questionnaireTypes';
import NewQuestionnaireDialog from './NewQuestionnaireDialog';
import { getAllQuestionnaires } from '../assessment/questionnaireApi';
import EditQuestionnaireDialog from './EditQuestionnaireDialog';
import QuestionnaireDialog from './QuestionnaireDialog';
import QuestionnaireList from '../../components/questionnaire/unansweredQuestionnaire/QuestionnaireList';
import { Fab } from '@material-ui/core';

interface Props {
  renderSearch: (showSearch: boolean) => void;
  searchText: IObservableValue<string>;
}

type LocalStyles = 'button';

const localStyles: StyleRulesCallback<LocalStyles> = theme => ({
  button: {
    margin: theme.spacing.unit,
    right: theme.spacing.unit * 2,
    bottom: theme.spacing.unit * 2,
    position: 'fixed'
  },
});

type PropsWithStyle = WithStyles<LocalStyles> & Props;

@observer
class Questionnaires extends React.Component<PropsWithStyle> {

  private loading: IObservableValue<boolean> = observable.box(false);
  private openNewQuestionnaireDialog: IObservableValue<boolean> = observable.box(false);
  private openEditQuestionnaireDialog: IObservableValue<boolean> = observable.box(false);
  private openQuestionnaireDialog: IObservableValue<boolean> = observable.box(false);
  @observable private questionnaires: Page<QuestionnaireDto> = emptyPage();
  @observable private questionnaire: QuestionnaireDto & IObservableObject;
  @observable private pageAble: Pageable = defaultPageable();

  constructor(props: PropsWithStyle) {
    super(props);
    this.onCloseNewQuestionnaireDialog = this.onCloseNewQuestionnaireDialog.bind(this);

    this.props.renderSearch(true);
  }

  public componentDidMount(): void {
    observe(
      this.props.searchText,
      () => this.loadQuestionnaire()
    );
    this.loadQuestionnaire();
  }

  public render() {
    const {classes} = this.props;
    return (
      <>
        {this.loading.get() ?
          <Spinner/> :
          <>
            <QuestionnaireList
              onClick={(id, questionnaire) => {
                this.questionnaire = observable({...questionnaire});
                this.openQuestionnaireDialog.set(true);
              }}
              secondaryClick={(questionnaire) => this.onEditQuestionnaireClicked(questionnaire)}
              handleChangePage={this.handleChangePage}
              questionnaires={this.questionnaires}
              emptyPage={<EmptyPage message={translation.t('noEntry.questionnaire.title')}
                                    searchText={this.props.searchText.get()}
                                    displayFab={false}
              />
              }
            />
            <Fab color="primary" arial-label="Add" className={classes.button} onClick={this.onNewQuestionnaireClicked}>
              <AddIcon/>
            </Fab>
            <NewQuestionnaireDialog
              open={this.openNewQuestionnaireDialog.get()}
              onClose={this.onCloseNewQuestionnaireDialog}
              onSave={this.createNewQuestionnaire}
            />

            <EditQuestionnaireDialog
              onClose={this.onCloseEditQuestionnaireDialog}
              onSave={this.updateQuestionnaire}
              open={this.openEditQuestionnaireDialog.get()}
              questionnaire={this.questionnaire}/>

            <QuestionnaireDialog
              onClose={this.onCloseQuestionnaireDialog}
              questionnaire={this.questionnaire}
              open={this.openQuestionnaireDialog.get()}/>
          </>
        }
      </>
    );
  }

  private handleChangePage = (event: any, page: number) => {
    this.pageAble.page = page;
    this.loadQuestionnaire()
  };

  private loadQuestionnaire() {
    this.loading.set(true);
    getAllQuestionnaires({searchText: this.props.searchText.get()}, this.pageAble)
      .then(page => {
        this.questionnaires = page;
        this.loading.set(false);
      })
  }

  private onEditQuestionnaireClicked = (questionnaireDto: QuestionnaireDto) => {
    this.questionnaire = observable({...questionnaireDto});
    this.openEditQuestionnaireDialog.set(true);
  };

  private updateQuestionnaire = () => {
    this.loadQuestionnaire();
    this.onCloseEditQuestionnaireDialog();
  };

  private readonly onCloseEditQuestionnaireDialog = () => {
    this.openEditQuestionnaireDialog.set(false);
  };

  private onNewQuestionnaireClicked = () => {
    this.openNewQuestionnaireDialog.set(true);
  };

  private createNewQuestionnaire = () => {
    this.loadQuestionnaire();
    this.onCloseNewQuestionnaireDialog();
  };

  private readonly onCloseNewQuestionnaireDialog = () => {
    this.openNewQuestionnaireDialog.set(false);
  };

  private readonly onCloseQuestionnaireDialog = () => {
    this.openQuestionnaireDialog.set(false);
  };

}

export default withStyles(localStyles)(Questionnaires);
